





















































import { stripeState } from '@/store';
import { Component, Vue } from 'vue-property-decorator';
import Steps from '@/components/Steps.vue';
import SepaDirectDebitCard from '@/components/SepaDirectDebitCard.vue';

@Component({ components: { Steps, SepaDirectDebitCard } })
export default class PaymentMethodSelectSepaDirectDebitPage extends Vue {
  public selectedSepaDirectDebitId: string = '';

  public get sepaDirectDebitObjects() {
    return stripeState.sepaDirectDebits;
  }

  public get buttonEnabled() {
    return this.selectedSepaDirectDebitId;
  }

  public created() {
    if (!stripeState.sepaDirectDebits || !stripeState.sepaDirectDebits[0]) {
      this.$router.push('/payment-methods/create/sepa-direct-debit');
    }

    document.title = `${this.$t(this.$route.meta.title)} | Comply`;
    if (!stripeState.selectedPlanId) {
      this.$router.push('/');
    }
  }

  public handleNextStep() {
    stripeState.SET_SELECTED_SEPA_DIRECT_DEBIT_ID(
      this.selectedSepaDirectDebitId,
    );
    this.$router.push('/confirm');
  }
}
